export enum LineOfBusiness {
  Commercial = 'Commercial',
  Medicaid = 'Medicaid',
  MedicareAdvantage = 'Medicare Advantage',
}

export interface LineOfBusinessReference {
  lineOfBusinessId: string;
  description: string;
  applicationKey: LineOfBusiness;
}

export type LineOfBusinessMap = Record<LineOfBusiness, LineOfBusinessReference>;
